module.exports = __webpack_public_path__ + "static/media/result.69e5db6a.svg";